import ApiFetcher3 from './ApiFetcher3';

class SearchBetaServiceApi {
  static getContent(params) {
    return ApiFetcher3.get('search/', params);
  }

  static getSchema(params) {
    return ApiFetcher3.get('search/schema/', params);
  }
}

export default SearchBetaServiceApi;
